import React, { useState, useRef, useEffect } from "react";
import { GET } from "../../Utils/api";

const Timer = props => {
	const Ref = useRef(null);
	const checkPaymentRef = useRef(null);
	const [timer, setTimer] = useState("00:00:00");

	const getTimeRemaining = e => {
		const total = Date.parse(e) - Date.parse(new Date());
		const seconds = Math.floor((total / 1000) % 60);
		const minutes = Math.floor((total / 1000 / 60) % 60);
		const hours = Math.floor((total / 1000 / 60 / 60) % 24);
		return {
			total,
			hours,
			minutes,
			seconds,
		};
	};

	const startTimer = e => {
		let { total, hours, minutes, seconds } = getTimeRemaining(e);
		if (total === 0) {
			clearInterval(Ref.current);
			clearInterval(checkPaymentRef.current);
			props.doneWithCounter(true);
		}

		if (total >= 0) {
			setTimer(
				(hours > 9 ? hours : "0" + hours) +
					":" +
					(minutes > 9 ? minutes : "0" + minutes) +
					":" +
					(seconds > 9 ? seconds : "0" + seconds),
			);
		}
	};

	const clearTimer = e => {
		setTimer(props.timerDesign);
		if (Ref.current || !props.showModal) {
			clearInterval(Ref.current);
		}
		const id = setInterval(() => {
			startTimer(e);
		}, 1000);
		Ref.current = id;
	};

	const getDeadTime = () => {
		let deadline = new Date();
		deadline.setSeconds(deadline.getSeconds() + props.timeInSecs);
		return deadline;
	};

	const getApi = async e => {
		let { total } = getTimeRemaining(e);
		if (total === 0) {
			clearInterval(Ref.current);
			clearInterval(checkPaymentRef.current);
			props.doneWithCounter(true);
		}
		if (total >= 0) {
			let response = await GET(
				`OmniPay/RetriveOmnipayPaymentBreakdownOMS?orderId=${props.order.Orderid}`,
			);
			if (response) {
				const {
					VirtualAccountAmount,
					BNPLAmount,
					OmoniPoint,
					CashAmountCollectedByDriver,
					IsPaid,
					Amount,
					IsDriverAmountCollected,
				} = response;
				if (
					(VirtualAccountAmount > 0 || BNPLAmount > 0 || OmoniPoint > 0) &&
					CashAmountCollectedByDriver <= 0 &&
					IsPaid === 1
				) {
					clearInterval(checkPaymentRef.current);
					props.setToSuccessPage(true);
					props.closeModal();
				} else if (
					CashAmountCollectedByDriver > 0 &&
					Number(CashAmountCollectedByDriver) === Number(Amount) &&
					IsDriverAmountCollected === 1
				) {
					console.log("worked here");
					const data = {
						AmountPayable: Amount,
						WalletPayment: 0,
						CashAmount: CashAmountCollectedByDriver,
						OmoniPoint: OmoniPoint,
					};
					console.log(data);
					clearInterval(checkPaymentRef.current);
					props.closeModal();
					props.ShowDriverEnterOTP(true, data);
				} else if (
					CashAmountCollectedByDriver > 0 &&
					IsDriverAmountCollected !== 1
				) {
					const data = {
						AmountPayable: Amount,
						WalletPayment: VirtualAccountAmount + BNPLAmount,
						CashAmount: CashAmountCollectedByDriver,
						OmoniPoint: OmoniPoint,
					};
					clearInterval(checkPaymentRef.current);
					props.setToConfirmPaymentPage(data);
					props.isCashCollected(true);
					props.closeModal();
				} else if (IsPaid === 1) {
					clearInterval(checkPaymentRef.current);
					props.setToSuccessPage(true);
					props.closeModal();
				} else if (
					(VirtualAccountAmount > 0 || BNPLAmount > 0 || OmoniPoint > 0) &&
					IsDriverAmountCollected === 1
				) {
					const data = {
						AmountPayable: Amount,
						WalletPayment: VirtualAccountAmount + BNPLAmount,
						CashAmount: CashAmountCollectedByDriver,
						OmoniPoint: OmoniPoint,
					};
					clearInterval(checkPaymentRef.current);
					props.closeModal();
					props.ShowDriverEnterOTP(true, data);
				}
			}
		}
	};

	// const verifyPaymentFromApp = e => {
	// 	let { total, hours, minutes, seconds } = getTimeRemaining(e);
	// 	if (total >= 0) {
	// 		setTimer(
	// 			(hours > 9 ? hours : "0" + hours) +
	// 				":" +
	// 				(minutes > 9 ? minutes : "0" + minutes) +
	// 				":" +
	// 				(seconds > 9 ? seconds : "0" + seconds),
	// 		);
	// 	}
	// 	if (total == 0) {
	// 		clearInterval(Ref.current);
	// 		clearInterval(checkPaymentRef.current);
	// 		props.doneWithCounter(true);
	// 	}
	// };

	const startAPITimer = e => {
		let { total } = getTimeRemaining(e);
		if (total >= 0) {
			getApi(e);
		}
		if (total === 0) {
			clearInterval(checkPaymentRef.current);
		}
	};

	const clearGetApiTimer = e => {
		// api timer
		if (checkPaymentRef.current || !props.showModal) {
			clearInterval(checkPaymentRef.current);
		}
		const callApi = setInterval(() => {
			startAPITimer(e);
		}, 5000);
		checkPaymentRef.current = callApi;
	};

	useEffect(() => {
		clearTimer(getDeadTime());
		return () => clearInterval(Ref.current);
	}, [props.reset]);

	useEffect(() => {
		clearGetApiTimer(getDeadTime());
	}, [props.showModal, props.reset]);

	return <span>{timer}</span>;
};
export default Timer;
